// extracted by css-extract-rspack-plugin
export default {"content-wrapper":"WAuPVK","contentWrapper":"WAuPVK","list-wrapper":"UuuDuC","listWrapper":"UuuDuC"};